import { gql } from "_graphql-types-frontend";

export const GET_REPORT = gql(/* GraphQL */ `
  query getReport($id: ID!, $format: FormatOptions!) {
    report(id: $id, format: $format)
  }
`);

export const GET_CASE_STUDY_REPORT = gql(/* GraphQL */ `
  query getCaseStudyReport($id: String!) {
    caseStudyReport(id: $id)
  }
`);
